import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

function AdminUpdate() {
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [image, setImage] = useState(null);
  const adminId = localStorage.getItem("adminId");
  const navigate = useNavigate();

  useEffect(() => {
    const fetchAdmin = async () => {
      const formData = new FormData();
      formData.append("AdminId", adminId);
      try {
        const res = await axios.post(
          "https://visitguru.in/api/v1/admin/getAdmin",
          formData
        );
        if (res.data.success) {
          setFullName(res.data.data.fullName);
          setEmail(res.data.data.email);
        }
      } catch (err) {
        toast.error("Failed to fetch admin data");
      }
    };
    fetchAdmin();
  }, [adminId]);

  const handleSubmit = async () => {
    if (!fullName.trim() || !email.trim()) {
      toast.error("Name and email are required.");
      return;
    }

    try {
      const formData = new FormData();
      formData.append("fullName", fullName);
      formData.append("email", email);
      if (image) formData.append("image", image);

      const response = await axios.post(
        `https://visitguru.in/api/v1/admin/updateAdmin/${adminId}`,
        formData
      );

      if (response.data.success) {
        toast.success("Admin updated successfully!");
        navigate("/admin/dashboard");
      } else {
        toast.error("Update failed.");
      }
    } catch (error) {
      toast.error("Something went wrong. Try again later.");
    }
  };

  return (
    <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-blueGray-100 border-0">
      <div className="rounded-t bg-white mb-0 px-6 py-6">
        <div className="text-center flex justify-between">
          <h6 className="text-blueGray-700 text-xl font-bold">Update Admin</h6>
        </div>
      </div>
      <div className="flex-auto px-4 lg:px-10 py-10 pt-0">
        <form onSubmit={(e) => e.preventDefault()}>
          <div className="flex flex-wrap">
            <div className="w-full lg:w-12/12 px-4">
              <div className="relative w-full mb-3">
                <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2 mt-4">
                  Full Name
                </label>
                <input
                  type="text"
                  className="border-0 px-3 py-3 mt-2 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                  placeholder="Enter Full Name"
                  value={fullName}
                  onChange={(e) => setFullName(e.target.value)}
                />
              </div>

              <div className="relative w-full mb-3">
                <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2 mt-4">
                  Email
                </label>
                <input
                  type="email"
                  className="border-0 px-3 py-3 mt-2 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                  placeholder="Enter Email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>

              <div className="relative w-full mb-3">
                <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2 mt-4">
                  Profile Image
                </label>
                <input
                  type="file"
                  className="border-0 px-3 py-3 mt-2 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                  onChange={(e) => setImage(e.target.files[0])}
                />
              </div>
            </div>
          </div>

          <div className="flex justify-end w-full">
            <button
              className="bg-lightBlue-500 text-white active:bg-lightBlue-600 font-bold uppercase text-xs mt-2 px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none ease-linear transition-all duration-150"
              type="button"
              onClick={handleSubmit}
            >
              Update
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AdminUpdate;
